import React, {  useState } from 'react'
import '../assets/barrenav.css'
import { Link } from 'react-router-dom';

function BarreNav() {

    const [categories]= useState([
      {
        id: 1,
        image:"/images/categories/bestsellers.png",
        name: "Best sellers",
        title: "Vos gammes CBD et HHC préférées "
      },
      {
        id: 2,
        image:"/images/categories/nouveaute.png",
        name: "Nouveautés",
        title: "Les dernières nouveautés pour vous satisfaire  "
      },
      {
        id: 3,
        image:"/images/categories/fleur.png",
        name: "Fleurs",
        title: "CBD, CBG, HHC, HHCP, HHCO il y en a pour tout les goûts avec"
      },
      {
        id: 4,
        image:"/images/categories/resine.png",
        name: "Résines",
        title: "Résines et pollen de CBD & HHC puissantes ou douces"
      },
      {
        id: 5,
        image:"/images/categories/huile.png",
        name: "Huiles",
        title: "Huile CBD, CBG, HHC, Culinaire"
      },
      {
        id: 6,
        image:"/images/categories/comestible.png",
        name: "Commestibles",
        title: "Les bienfaits du CBD à travers des thés, tisanes, bonbons, huiles pour vos plats en cuisine"
      },
      {
        id: 7,
        name: "E-liquide",
        image:"/images/categories/e-liquide.png",
        title: "E-liquide HHC et E-liquide HHC ainsi que le matériel adapté",
      },
      {
        id: 8,
        name: "E-cigarette",
        title: "Pod HHC, pod CBD, Puff, cigarette électronique HHC et CBD",
        image:"/images/categories/e-cigarette.png",

      },
      {
        id: 9,
        name: "Vaporisateur",
        title: "Idéal pour la vaporisation de CBD/HHC",
        image:"/images/categories/vaporisateur.png",

      },
      {
        id: 10,
        name: "Soins",
        title: "Pour une meilleure récupération musculaire",
        image:"/images/categories/soins.png",

      },
      {
        id: 11,
        name: "Animaux",
        title: "Parce que eux aussi ont le droit au CBD",
        image:"/images/categories/animaux.png",

      },
    ]);
    return (
          <nav className="navbar navbar-expand-lg navbar-dark" id='navmenu'>
            <div className="container-fluid" id='barnavig'>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
              <img src={window.location.origin +"/images/menuburger.svg"} alt="" />
              </button>
              <div className="collapse navbar-collapse" id="navbarMenu">
                <div id="collapseHead">
                <Link className="navbar-brand ms-md-auto ms-lg-auto" to={'/'}>
                    <img src={window.location.origin +"/images/logo.svg"} className='logoapp' alt=""  />
                </Link>
                  <button className="" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
                  <img src={window.location.origin +"/images/close.svg"}  className='logoapp' alt=""  />
                </button>
                </div>
                <ul className="navbar-nav">
                  
                  <li className="nav-item dropdown">
                    <Link className="nav-link active dropdown-toggle" id='catItem' to={"#"} role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    CATÉGORIES
                    </Link>
                    <ul className="dropdown-menu">
                      {categories.map(cat => 
                        <li key={cat.id}><Link className="dropdown-item" to={window.location.origin+"/categories/"+cat.id}><img src={window.location.origin +cat.image} className="me-1" alt="" />{cat.name}</Link></li>)}
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to={"/suivre-ma-commande"}>SUIVRE MA COMMANDE</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to={"#"}>PROGRAMME DE FIDÉLITÉ</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to={"/blog"}>BLOG</Link>
                  </li>
                </ul>
                <div className="menuMobile">
                  <Link to={window.location.origin+"/mon-compte"}><img src={window.location.origin +"/images/login.svg"} className="me-1" alt="" /> <span className='mt-2'>CONNEXION</span> </Link>
                  <Link to={window.location.origin+"/creation-compte"}><img src={window.location.origin +"/images/logout.svg"} className="me-1" alt="" /> <span className='mt-2'>CRÉER UN COMPTE</span> </Link>
                  <div className="instagram">
                    <span>SUIVEZ-NOUS POUR TOUTES LES EXCLUSIVITÉS</span>
                    <img src={window.location.origin +"/images/instagram.svg"}  alt="" />
                  </div>
                </div>
              </div>
              
            </div>
          </nav>
    );
}

export default BarreNav